"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ERememberedAccountType = void 0;
let ERememberedAccountType = exports.ERememberedAccountType = /*#__PURE__*/function (ERememberedAccountType) {
  ERememberedAccountType["Phone"] = "phone";
  ERememberedAccountType["Email"] = "email";
  return ERememberedAccountType;
}({});